const DEVICE_ID_STORAGE_KEY = "carepro:deviceId";

/**
 * Returns a stable per-browser device identifier for auth API calls.
 * Generated once and persisted in localStorage.
 */
export function getOrCreateDeviceId(): string {
  if (typeof window === "undefined") {
    return "server";
  }

  try {
    const existing = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (existing && existing.trim()) {
      return existing.trim();
    }

    const nextId =
      typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : `device-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;

    window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, nextId);
    return nextId;
  } catch {
    return `device-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
  }
}

/** @internal Test helper */
export function resetDeviceIdForTests(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(DEVICE_ID_STORAGE_KEY);
  } catch {
    // ignore
  }
}
